export default __webpack_public_path__ + "static/media/wallet.d009f2b9.jpg";